import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { IremboPaginationComponent } from '@irembo-andela/irembogov3-common';

@Component({
  selector: 'irembogov-inline-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent
  extends IremboPaginationComponent
  implements OnChanges
{
  override ngOnChanges(changes: SimpleChanges) {
    if (changes['page'] && changes['page'].currentValue) {
      this.pagination.pageNumber = changes['page'].currentValue;
    }
    if (!!changes['pageSize'] && !!changes['pageSize']?.currentValue) {
      this.pagination = {
        ...this.pagination,
        pageSize: changes['pageSize']?.currentValue,
      };
    }
  }
}
